import { render, staticRenderFns } from "./SectionFee.vue?vue&type=template&id=19d6d0ac&scoped=true&"
import script from "./SectionFee.vue?vue&type=script&lang=js&"
export * from "./SectionFee.vue?vue&type=script&lang=js&"
import style0 from "./SectionFee.vue?vue&type=style&index=0&id=19d6d0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6d0ac",
  null
  
)

export default component.exports